import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Column from './Column';
import Header from './Header';


const FlexibleTable = ({ className, children, data, onRowClick, onRowHover, returnIndex }) => (
    <div className={classNames('flexible-table', className)}>
        {
            data.map((row, i) => (
                <div
                    className="flexible-table__row"
                    key={i}
                    onClick={() => onRowClick && onRowClick(returnIndex ? i : row)}
                    onMouseEnter={() => onRowHover && onRowHover(returnIndex ? i : row)}
                >
                    <span className="flexible-table__thead">
                        {
                            React.Children.map(children, child => {
                                return child.type === <Header />.type
                                ? (
                                    <h4 className="flexible-table__row__header">
                                        {
                                            child.props.format
                                            ? child.props.format(row[child.props.dataKey], i)
                                            :  row[child.props.dataKey]
                                        }
                                    </h4>
                                )
                                : null
                            })
                        }
                    </span>
                    <span className="flexible-table__tbody">
                        {
                            React.Children.map(children, child => (
                                child.type === <Column />.type
                                ? (
                                    <div className="flexible-table__row__cell">
                                        <span className="flexible-table__row__cell__title">
                                            {child.props.header}
                                        </span>
                                        <span className="flexible-table__row__cell__content">
                                            {
                                                child.props.format
                                                ? child.props.format(row[child.props.dataKey], i)
                                                : row[child.props.dataKey]
                                            }
                                        </span>
                                    </div>
                                )
                                : null
                            ))
                        }
                    </span>
                </div>
            ))
        }
    </div>
);


FlexibleTable.defaultProps = {
    returnIndex: false,
};

FlexibleTable.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    data: PropTypes.array.isRequired,
    onRowClick: PropTypes.func,
    onRowHover: PropTypes.func,
    returnIndex: PropTypes.bool,
};


export default FlexibleTable;
